import { render } from "./RecordBoardView.vue?vue&type=template&id=46e0370a&scoped=true&ts=true"
import script from "./RecordBoardView.vue?vue&type=script&lang=ts"
export * from "./RecordBoardView.vue?vue&type=script&lang=ts"

import "./RecordBoardView.vue?vue&type=style&index=0&id=46e0370a&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-46e0370a"]])

export default __exports__